import { render, staticRenderFns } from "./octopart-integration.vue?vue&type=template&id=cc8fa5ba&"
import script from "./octopart-integration.vue?vue&type=script&lang=js&"
export * from "./octopart-integration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MarketingPage1: require('/opt/build/repo/components/elements/MarketingPage1.vue').default})
